import React from 'react';
import Section from '../Section/Section';
import BlockDiagram from '../BlockDiagram/BlockDiagram';
import ConvergeDemo from './ConvergeDemo';
import { projects } from '../../data/portfolioData';
import { projectDiagrams } from '../../data/diagrams';
import { useRepoMeta, formatDate } from '../../lib/useRepoMeta';
import './Projects.css';

/** Live facts for one repo: skeletons while loading, quiet on failure. */
const RepoLine = ({ meta, url }) => {
  if (meta === null) {
    return (
      <>
        <span className="skeleton skeleton-chip" aria-hidden="true" />
        <span className="skeleton skeleton-chip" aria-hidden="true" />
      </>
    );
  }
  const repo = meta[url];
  if (!repo) return null;
  if (repo.missing) return <span>private repository</span>;
  return (
    <>
      {repo.language && <span>{repo.language}</span>}
      <span>last push {formatDate(repo.pushedAt)}</span>
    </>
  );
};

export const Projects = () => {
  const meta = useRepoMeta(projects.map((p) => p.links.github));

  return (
    <Section id="projects" path="projects/" title="Projects">
      {projects.map((project) => (
        <article className="project" key={project.id} id={`project-${project.slug}`}>
          <p className="project-path">projects/{project.slug}</p>
          <h3 className="project-title">{project.title}</h3>
          <p className="project-summary">{project.summary}</p>

          <p className="project-meta" aria-busy={meta === null}>
            <span>{project.date}</span>
            <RepoLine meta={meta} url={project.links.github} />
            <a className="link" href={project.links.github} target="_blank" rel="noreferrer">
              source
            </a>
          </p>

          <p className="project-long">{project.longDescription}</p>

          <ul className="marks">
            {project.features.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>

          <ul className="tags project-tags">
            {project.technologies.map((tech) => (
              <li key={tech}>{tech}</li>
            ))}
          </ul>

          {projectDiagrams[project.slug] && (
            <BlockDiagram diagram={projectDiagrams[project.slug]} />
          )}

          {project.slug === 'converge' && (
            <section className="project-demo" aria-labelledby="converge-demo-title">
              <h4 className="sub-head" id="converge-demo-title">
                Try it: two replicas, one link you can cut
              </h4>
              <p className="demo-intro">
                The same kind of sequence CRDT as Converge, running in your
                browser with no server. Cut the link, type in both boxes, then
                restore it. Each character carries a Lamport id, deletes leave
                tombstones, and both sides settle on the same text no matter
                what order the edits arrive in.
              </p>
              <ConvergeDemo />
            </section>
          )}
        </article>
      ))}
    </Section>
  );
};

export default Projects;
